import { faSave } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { CertificateType } from "../api/dto";
import type { QuestionSet } from "../api/dto/QuestionSet";
import { Input } from "../components/form/Input";
import { Select } from "../components/form/Select";
import { Toggle } from "../components/form/Toggle";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const EditCertificateTypeModal: FC<{
  certificateType: CertificateType;
  questionSets: QuestionSet[];
}> = (props) => {
  const refresh = useRefresh();
  const { editCertificateType } = useApiCall();
  const [name, setName] = useState<string>(props.certificateType.name ?? "");
  const [questionSet, setQuestionSet] = useState<string>(
    props.certificateType.question_set_id ?? "",
  );
  const [isActive, setIsActive] = useState<boolean>(props.certificateType.is_active);
  const [errors, setErrors] = useState<string[]>([]);

  const questionSetMap = props.questionSets.map((item) => [item.id, item.name]);

  const save = async () => {
    await editCertificateType(props.certificateType.id, name, questionSet, isActive).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };

  return (
    <div className={"flex flex-col space-y-4"}>
      <div className={""}>
        <Input type={"text"} label={"Naam"} value={name} onChange={setName} maxWidth={"full"} />
      </div>
      <div>
        <Select
          label={"Question set"}
          options={Object.fromEntries(questionSetMap)}
          value={questionSet}
          onChange={setQuestionSet}
        />
      </div>
      <div>
        <Toggle label={"Actief"} value={isActive} onChange={setIsActive} />
      </div>
      <ModalFooter text={"Opslaan"} icon={faSave} onSubmit={save} />
    </div>
  );
};
